import './SectionOne.css';

import React from 'react';

import { useNavigate } from 'react-router-dom';

export default function SectionOne() {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/register");
  };

  return (
    <div className="hh-hero">
      {/* Headline — left zone, sits above the box */}
      <div className="hh-hero__hl">
        <p className="hh-hero__eyebrow">
          <span className="hh-eyebrow-rule"></span>
          Modern Jewish Dating
        </p>
        <h1 className="hh-hero__title">
          Start Finding<br />Your Date
        </h1>
      </div>

      {/* Man portrait — bottom left */}
      <div className="hh-hero__man">
        <img
          src="https://images.pexels.com/photos/20374107/pexels-photo-20374107/free-photo-of-portrait-of-man.jpeg?auto=compress&cs=tinysrgb&w=600&h=900&dpr=2"
          alt="Portrait"
        />
      </div>

      {/* Live activity badge */}
      <div className="hh-hero__live">
        <span className="hh-live__dot"></span>
        <div>
          <b className="hh-live__num">1,847</b>
          <span className="hh-live__lbl">online now</span>
        </div>
      </div>

      {/* Signature box */}
      <div className="hh-hero__box">

        {/* Left — body copy + CTA + social proof */}
        <div className="hh-hero__content">
          <p className="hh-hero__body">
            Discover love with Hebrew Hearts, where modern Jewish singles find
            meaningful matches by blending tradition with the modern world.
          </p>

          <div className="hh-hero__actions">
            <button className="hh-btn-start" onClick={handleNavigate}>
              Start Now
            </button>
            <button className="hh-btn-how" onClick={() => navigate('/how-it-works')}>
              How it works&nbsp;<span className="hh-arrow">→</span>
            </button>
          </div>

          <div className="hh-hero__proof">
            <div className="hh-proof__avs">
              {[7, 8, 9, 10].map(i => (
                <div key={i} className="hh-proof__av">
                  <img src={`https://i.pravatar.cc/60?img=${i}`} alt="" />
                </div>
              ))}
            </div>
            <div className="hh-proof__copy">
              <div><span className="hh-proof__stars">★★★★★</span> <strong>4.9</strong></div>
              <div>Trusted by <strong>12,000+</strong> singles</div>
            </div>
          </div>
        </div>

        {/* Right — woman portrait with floating match card */}
        <div className="hh-hero__photo-col">
          <div className="hh-photo-img"></div>
          <div className="hh-photo-fade"></div>

          <div className="hh-match-float">
            <div className="hh-mf__av">
              <img src="https://i.pravatar.cc/100?img=47" alt="" />
            </div>
            <div>
              <span className="hh-mf__name">Rachel, 28</span>
              <div className="hh-mf__meta">
                <span className="hh-mf__dot"></span>
                <span className="hh-mf__sub">Online · 5 mi away</span>
              </div>
            </div>
            <div className="hh-mf__badge">87% match</div>
          </div>
        </div>

      </div>
    </div>
  );
}
